import { render } from "./PokemonCard.vue?vue&type=template&id=4986366a&scoped=true"
import script from "./PokemonCard.vue?vue&type=script&lang=js"
export * from "./PokemonCard.vue?vue&type=script&lang=js"

import "./PokemonCard.vue?vue&type=style&index=0&id=4986366a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4986366a"

export default script